import FirebaseClient from './../services/Firebase'
import axios from 'axios'
import config from './../config/AppConfig.js'

export function removePerfil(perfil, user) {
  return function(dispatch) {
    FirebaseClient.database()
      .ref('/user/' + user.uid + '/profiles/' + perfil.key)
      .remove(error => {
        if (error === null) {
          FirebaseClient.database()
            .ref('/profile/' + perfil.key)
            .remove(error => {
              if (error === null) {
                dispatch({
                  type: 'REMOVE_PROFILE',
                  payload: perfil
                })
              }
            })
        }
      })
  }
}

export function savePerfil(data, user, callbackFunctions) {
  return function(dispatch) {
    if (data.key === -1) {
      FirebaseClient.auth().currentUser.getIdToken().then(token => {
        axios({
          method: 'post',
          url: config.baseUrl + 'createProfile',
          headers: { Authorization: 'Bearer ' + token },
          data: {
            name: data.name,
            password: data.password
          }
        })
          .then(function(responseCreateProfile) {
            //Ya tengo el perfil - Ahora le agrego los código.
            const profileCodes = Object.assign({}, responseCreateProfile.data, {
              code: data.code,
              name: data.name,
              password: data.password
            })

            //En todos los casos devuelvo el perfil al objeto:
            callbackFunctions.success(
              Object.assign({}, responseCreateProfile.data, data.profile, {
                name: data.name,
                password: data.password
              }),
              'El perfil se ha creado correctamente'
            )

            //Se puede crear si código
            if (profileCodes.code.length === 0) return

            axios({
              method: 'post',
              url: config.baseUrl + 'validateCode',
              headers: { Authorization: 'Bearer ' + token },
              data: profileCodes
            })
              .then(function(responseValidateCode) {
                //Actualizo el objeto:
                FirebaseClient.database()
                  .ref('/profile/' + responseCreateProfile.data.key)
                  .once('value', profile => {
                    callbackFunctions.success(
                      Object.assign({}, profile.val(), {
                        code: '-1'
                      }),
                      'Listo! Ingresa a las apps y podrás leer los libros'
                    )

                    //Los libros vienen en books.
                    dispatch({
                      type: 'FETCH_PROFILE',
                      payload: {
                        key: responseCreateProfile.data.key,
                        object: profile.val()
                      }
                    })
                  })
              })
              .catch(function(error) {
                //El código de activación es incorrecto:
                callbackFunctions.error({
                  errorMessageName: null,
                  errorMessagePin: null,
                  errorMessageCode: 'El código de activación es incorrecto',
                  profile: Object.assign({}, data.profile, {
                    code: ''
                  })
                })
              })
          })
          .catch(error => {
            console.log(error)
            //El código de activación es incorrecto:
            callbackFunctions.error({
              errorMessageName: 'Hubo un error al crear el perfil',
              errorMessagePin: null,
              errorMessageCode: null
            })
          })
      })
    } else {
      //Actualizo los datos del profile

      FirebaseClient.auth().currentUser.getIdToken().then(token => {
        axios({
          method: 'post',
          url: config.baseUrl + 'updateProfile',
          headers: { Authorization: 'Bearer ' + token },
          data: {
            key: data.key,
            name: data.name,
            password: data.password
          }
        })
          .then(function(responseUpdateProfile) {
            //Ya tengo el perfil - Ahora le agrego los código.
            const profileCodes = Object.assign(
              {},
              {
                key: data.key,
                code: data.code
              }
            )

            //Solo devuelvo el OK cuando el name o password cambió
            if (true) {
              callbackFunctions.success(
                Object.assign({}, responseUpdateProfile.data, data.profile, {
                  name: data.name,
                  password: data.password
                }),
                'El perfil se ha editado correctamente'
              )
            }

            if (profileCodes.code.length > 0) {
              axios({
                method: 'post',
                url: config.baseUrl + 'validateCode',
                headers: { Authorization: 'Bearer ' + token },
                data: profileCodes
              })
                .then(function(responseValidateCode) {
                  //Actualizo el objeto:
                  FirebaseClient.database()
                    .ref('/profile/' + data.profile.key)
                    .once('value', profile => {
                      callbackFunctions.success(
                        Object.assign({}, profile.val(), {
                          code: '-1'
                        }),
                        'Listo! Ingresa a las apps y podrás leer los libros'
                      )

                      //Los libros vienen en books.
                      dispatch({
                        type: 'FETCH_PROFILE',
                        payload: {
                          key: data.profile.key,
                          object: profile.val()
                        }
                      })
                    })
                })
                .catch(function(error) {
                  //El código de activación es incorrecto:
                  callbackFunctions.error({
                    errorMessageName: null,
                    errorMessagePin: null,
                    errorMessageCode:
                      'El código de activación no es correcto o ya está en uso.',
                    profile: Object.assign({}, data.profile, {
                      code: ''
                    })
                  })
                })
            } //End if
          })
          .catch(function(error) {
            callbackFunctions.error({
              errorMessageName: 'Ha ocurrido un error al editar el perfil',
              errorMessagePin: null,
              errorMessageCode: null
            })
          })
      })
    }
  }
}

export function fetchProfiles(user) {
  return function(dispatch) {
    FirebaseClient.database()
      .ref('/user/' + user.uid + '/profiles')
      .on('value', snapshot => {
        const data = snapshot.val()

        if (data !== null) {
          Object.keys(data).forEach(key => {
            //Cada key es un book
            FirebaseClient.database()
              .ref('/profile/' + key)
              .once('value', profile => {
                //Los libros vienen en books.
                dispatch({
                  type: 'FETCH_PROFILE',
                  payload: {
                    key: key,
                    object: profile.val()
                  }
                })
              })
          })
        }
      })
  }
}

export function saveRedirectURL(url) {
  return {
    type: 'SAVE_REDIRECT_URL',
    payload: url
  }
}

function storageAvailable(type) {
  try {
    var storage = window[type],
      x = '__storage_test__'
    storage.setItem(x, x)
    storage.removeItem(x)
    return true
  } catch (e) {
    return false
  }
}

export function login(user, callback) {
  return function(dispatch) {
    FirebaseClient.auth()
      .signInWithEmailAndPassword(user.username, user.password)
      .then(function(firebaseUser) {
        if (firebaseUser) {
          dispatch({
            type: 'LOGIN',
            payload: firebaseUser
          })
        }
      })
      .catch(function(error) {
        if (!storageAvailable('localStorage')) {
          dispatch({
            type: 'ERROR',
            payload: {
              login:
                'Ha ocurrido un error. Tu navegador parece estar en modo incognito. Ebooks Patagonia no puede funcionar en este modo. Por favor desactiva el modo incognito e intenta de nuevo.',
              register: null,
              forgot: null
            }
          })
        } else {
          dispatch({
            type: 'ERROR',
            payload: {
              login:
                'Ha ocurrido un error, revisa que el correo electrónico y la contraseña sean correctas.',
              register: null,
              forgot: null
            }
          })
        }

        callback()
      })
  }
}

export function forgotPassword(user, callback) {
  return function(dispatch) {
    FirebaseClient.auth()
      .sendPasswordResetEmail(user.username)
      .then(function() {
        dispatch({
          type: 'SUCCESS',
          payload: {
            login: null,
            register: null,
            forgot: 'Revisa tu email para actualizar tu contraseña.'
          }
        })
        callback()
      })
      .catch(function(error) {
        dispatch({
          type: 'ERROR',
          payload: {
            login: null,
            register: null,
            forgot: error.message.replace(
              'There is no user record corresponding to this identifier. The user may have been deleted.',
              'El email ingresado no está registrado'
            )
          }
        })
      })
  }
}

export function register(user, callback) {
  return function(dispatch) {
    FirebaseClient.auth()
      .createUserWithEmailAndPassword(user.username, user.password)
      .then(function(firebaseUser) {
        if (firebaseUser) {
          firebaseUser
            .updateProfile({
              displayName: user.name
            })
            .then(
              function() {
                // Update successful
                dispatch({
                  type: 'LOGIN',
                  payload: FirebaseClient.auth().currentUser
                })
              },
              function(error) {
                // An error happened.
              }
            )
        }
      })
      .catch(function(error) {
        dispatch({
          type: 'ERROR',
          payload: {
            login: null,
            register: error.message.replace(
              'The email address is already in use by another account.',
              'El correo electrónico ingresado está siendo usado en otra cuenta'
            ),
            forgot: null
          }
        })

        callback()
      })
  }
}

export function updateTitle(value) {
  return {
    type: 'UPDATE_TITLE',
    payload: value
  }
}

export function logout(user, callback) {
  return function(dispatch) {
    FirebaseClient.auth().signOut().then(
      function() {
        // Sign-out successful.
        dispatch({
          type: 'LOGOUT',
          payload: {
            user: user,
            callback: callback
          }
        })

        callback()
      },
      function(error) {
        console.error(`ERROR LOG OUT: ${error}`)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js